//#region ../src/ar/rgba-image-data.ts
/**
* Wrap `frame` in `ImageData`, adopting its array when possible (no copy) and
* copying only when `ImageData` cannot take it - a view over shared memory.
* Frames from `captureToRgba` are plain-ArrayBuffer-backed owned copies, so
* they are always adopted. The caller must not mutate the array afterwards.
*/
function rgbaToImageData(frame) {
	const { data, width, height } = frame;
	const pixels = data.buffer instanceof ArrayBuffer ? data : new Uint8ClampedArray(data);
	return new ImageData(pixels, width, height);
}
//#endregion
export { rgbaToImageData as t };
